const ITEMS = [
    "Technovale Solutions",
    "Software · SaaS · Marketing",
    "Build bold",
    "Ship in 6 weeks",
    "Growth that compounds",
    "Made for ambitious teams",
];

export default function Marquee() {
    const loop = [...ITEMS, ...ITEMS, ...ITEMS];
    return (
        <section
            data-testid="marquee-section"
            className="bg-brand-pink border-y-4 border-ink overflow-hidden"
        >
            <div className="flex animate-marquee whitespace-nowrap py-6">
                {loop.map((t, i) => (
                    <span
                        key={i}
                        className="font-display text-3xl md:text-5xl font-black uppercase tracking-tight px-8 flex items-center gap-8"
                    >
                        {t}
                        <span className="w-3 h-3 rounded-full bg-brand-blue border-2 border-ink" />
                    </span>
                ))}
            </div>
        </section>
    );
}
